module.exports = __webpack_public_path__ + "img/img3.703da343.jpg";